module.exports = __webpack_public_path__ + "files/a8f8a7dce02df4357bb72091db244fb7.png";